import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: null,
  error: "",
  status: "idle",
  addError: "",
  addStatus: "idle",
  addSubjectStatus: "idle",
  addSubjectError: "",
  editSubjectStatus: "idle",
  editSubjectError: "",
  editTopicStatus: "idle",
  editTopicError: "",
  deleteTopicStatus: "idle",
  deleteTopicError: "",
  deleteSubjectStatus: "idle",
  deleteSubjectError: "",
};

export const fetchTopics = createAsyncThunk(
  "topic/fetchTopics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get("/topic/topicandsubject");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const addTopic = createAsyncThunk(
  "topic/addTopic",
  async (topicName, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/topic/create", topicName);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const addSubject = createAsyncThunk(
  "topic/addSubject",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.post("/subject/create", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const editSubject = createAsyncThunk(
  "topic/editSubject",
  async (userData, { rejectWithValue }) => {
    try {
      const { id, data } = userData;
      const response = await PRIVATE_API.put(`/subject/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const editTopic = createAsyncThunk(
  "topic/editTopic",
  async (userData, { rejectWithValue }) => {
    try {
      const { id, data } = userData;
      const response = await PRIVATE_API.put(`/topic/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const deleteTopic = createAsyncThunk(
  "topic/deleteTopic",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.delete(`/topic/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const deleteSubject = createAsyncThunk(
  "topic/deleteSubject",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.delete(`/subject/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

const topicSlice = createSlice({
  name: "topic",
  initialState,
  reducers: {
    setAddTopicIdleStatus: (state) => {
      state.addStatus = "idle";
      state.addError = "";
    },
    setAddSubjectIdleStatus: (state) => {
      state.addSubjectStatus = "idle";
      state.addSubjectStatus = "";
    },
    setEditAndDeleteTopicandSubjectIdleStatus: (state) => {
      state.editSubjectStatus = "idle";
      state.editSubjectError = "";
      state.editTopicStatus = "idle";
      state.editTopicError = "";
      state.deleteTopicStatus = "idle";
      state.deleteTopicError = "idle";
      state.deleteSubjectStatus = "idle";
      state.deleteSubjectError = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL TOPICS
      .addCase(fetchTopics.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchTopics.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
      })
      .addCase(fetchTopics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })

      // ADD A TOPIC
      .addCase(addTopic.pending, (state, action) => {
        state.addStatus = "loading";
        state.addError = "";
      })
      .addCase(addTopic.fulfilled, (state, action) => {
        state.addStatus = "success";
        state.addError = "";
        state.data = [
          ...state.data,
          {
            _id: action.payload.data._id,
            topicName: action.payload.data.topicName,
            subjectDetails: [],
          },
        ];
      })
      .addCase(addTopic.rejected, (state, action) => {
        state.addStatus = "failed";
        state.addError = action.payload.message;
      })

      // edit Topic
      .addCase(editTopic.pending, (state, action) => {
        state.editTopicStatus = "loading";
        state.editTopicError = "";
      })
      .addCase(editTopic.fulfilled, (state, action) => {
        state.editTopicStatus = "success";
        state.editTopicError = "";
        // console.log(action.payload.data);
        state.data = state.data?.map((topic) =>
          topic?._id === action?.payload?.data?._id
            ? { ...topic, topicName: action.payload.data.topicName }
            : topic
        );
      })
      .addCase(editTopic.rejected, (state, action) => {
        state.editTopicStatus = "failed";
        state.editTopicError = action.payload.message;
        // console.log(action);
      })

      // Delete topic
      .addCase(deleteTopic.pending, (state, action) => {
        state.deleteTopicStatus = "loading";
        state.deleteTopicError = "";
      })
      .addCase(deleteTopic.fulfilled, (state, action) => {
        state.deleteTopicStatus = "success";
        state.deleteTopicError = "";
        state.data = state.data?.filter(
          (topic) => topic?._id !== action?.payload?.data
        );
      })
      .addCase(deleteTopic.rejected, (state, action) => {
        state.deleteTopicStatus = "failed";
        state.deleteTopicError = action.payload.message;
        // console.log(action);
      })

      // Add a subject
      .addCase(addSubject.pending, (state, action) => {
        state.addSubjectStatus = "loading";
        state.addSubjectError = "";
      })
      .addCase(addSubject.fulfilled, (state, action) => {
        state.addSubjectStatus = "success";
        state.addSubjectError = "";
        state.data = state.data.map((entry) =>
          entry._id === action.payload.data.topicId
            ? {
                ...entry,
                subjectDetails: [
                  ...entry.subjectDetails,
                  action.payload.data.newSubject,
                ],
              }
            : entry
        );
      })
      .addCase(addSubject.rejected, (state, action) => {
        state.addSubjectStatus = "failed";
        state.addSubjectError = action.payload.message;
      })

      // edit Subject
      .addCase(editSubject.pending, (state, action) => {
        state.editSubjectStatus = "loading";
        state.editSubjectError = "";
      })
      .addCase(editSubject.fulfilled, (state, action) => {
        state.editSubjectStatus = "success";
        state.editSubjectError = "";
        console.log(action.payload.data);
        state.data = state.data.map((entry) =>
          entry._id === action.payload.data.topicId
            ? {
                ...entry,
                subjectDetails: entry.subjectDetails.map((subject) =>
                  subject._id === action.payload.data.subject._id
                    ? {
                        ...subject,
                        subjectName: action.payload.data.subject.subjectName,
                      }
                    : subject
                ),
              }
            : entry
        );
      })
      .addCase(editSubject.rejected, (state, action) => {
        state.editSubjectStatus = "failed";
        state.editSubjectError = action.payload.message;
        // console.log(action);
      })

      // Delete subject
      .addCase(deleteSubject.pending, (state, action) => {
        state.deleteSubjectStatus = "loading";
        state.deleteSubjectError = "";
      })
      .addCase(deleteSubject.fulfilled, (state, action) => {
        state.deleteSubjectStatus = "success";
        state.deleteSubjectError = "";
        // console.log(action.payload.data);
        state.data = state.data.map((entry) =>
          entry._id === action.payload.data.topicId
            ? {
                ...entry,
                subjectDetails: entry.subjectDetails.filter(
                  (subject) => subject._id !== action.payload.data.subjectId
                ),
              }
            : entry
        );
      })
      .addCase(deleteSubject.rejected, (state, action) => {
        state.deleteSubjectStatus = "failed";
        state.deleteSubjectError = action.payload.message;
      });
  },
});

export const {
  setAddTopicIdleStatus,
  setAddSubjectIdleStatus,
  setEditAndDeleteTopicandSubjectIdleStatus,
} = topicSlice.actions;

export const getTopics = (state) => state.topic.data;
export const getTopicStatus = (state) => state.topic.status;
export const getTopicError = (state) => state.topic.error;

export const getAddTopicStatus = (state) => state.topic.addStatus;
export const getAddTopicError = (state) => state.topic.addError;
export const getAddSubjectStatus = (state) => state.topic.addSubjectStatus;
export const getAddSubjectError = (state) => state.topic.addSubjectError;

export const getEditSubjectStatus = (state) => state.topic.editSubjectStatus;
export const getEditSubjectError = (state) => state.topic.editSubjectError;

export const getEditTopicStatus = (state) => state.topic.editTopicStatus;

export const getDeleteTopicStatus = (state) => state.topic.deleteTopicStatus;
export const getDeleteTopicError = (state) => state.topic.deleteTopicError;

export const getDeleteSubjectStatus = (state) =>
  state.topic.deleteSubjectStatus;
export const getDeleteSubjectError = (state) => state.topic.deleteSubjectError;

export default topicSlice.reducer;
